<template>
  <div class="modal_box flex-col">
    <div class="select_wrap flex-row align-center">
      <zSelect v-model="queryParams.date" :options="selectList1" class="mr-10" @change="getList" />
      <zSelect v-model="queryParams.platform" :options="selectList2" class="mr-10" @change="getList" />
    </div>
    <div class="list">
      <template v-if="data.length">
        <div v-for="item in data" :key="item.transaction_id" class="item">
          <div class="mb-5 flex-row align-center justify-between">
            <div class="flex-row align-center">
              <div>{{ queryParams.platform.toUpperCase() }}Slots/</div>
              <div class="color5">
                {{ item.game_name }}
              </div>
            </div>
            <div>{{ item.createtime }}</div>
          </div>
          <div class="mb-5 flex-row align-center justify-between">
            <div>{{ $t("有效投注") }} &nbsp;<span class="f-w-b color5">{{ item.bet_amount }}</span></div>
            <div>V/D&nbsp;<span :class="[item.transfer_amount >= 0 ? 'red' : 'green']">{{ item.transfer_amount }}</span>
            </div>
          </div>
          <div class="flex-row align-center">
            {{ $t("投注请求 ID") }}
            <span class="id">{{ item.transaction_id }}</span>
            <i class="el-icon-copy-document copy" @click="doCopy(item.transaction_id)" />
          </div>
        </div>
      </template>
      <zEmpty v-else />
    </div>
  </div>
</template>
<script>
import zSelect from '../../../components/zSelect.vue';
import zEmpty from '../../../components/zEmpty.vue';
import Fetch from "../../../utils/fetch";
export default {
  components: {
    zSelect,
    zEmpty
  },
  data() {
    return {
      queryParams: {
        date: 0,
        platform: 'pg',
      },
      selectList1: [
        {
          value: 'Hoje',
          key: 0
        },
        {
          value: 'Ontem',
          key: 1
        },
        {
          value: 'Últimos 7 Dias',
          key: 7
        },
        {
          value: 'Últimos 15 Dias',
          key: 15
        },
        {
          value: 'Últimos 30 Dias',
          key: 30
        },
      ],
      selectList2: [
        {
          value: 'PG',
          key: 'pg'
        },
        {
          value: 'PP',
          key: 'pp'
        },
        {
          value: 'JDB',
          key: 'jdb'
        },
        {
          value: 'TADA',
          key: 'tada'
        },
      ],
      data: [
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(e) {
      Fetch("/record/gamebet", this.queryParams, { method: 'get' }).then((r) => {
        if (r.data) {
          this.data = r.data.list
          this.selectList2 = r.data.platform_list.map(item => ({
            value: item,
            key: item
          }))
          if (!e) {
            this.queryParams.platform = this.selectList2[0].key
          }
        }
      });
    },
    jumpDetail(item) {
      this.$router.push({
        path: '/report/detail',
        query: {
          id: item.id
        }
      })
    },

    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
  }
}
</script>
<style scoped lang="less">
@import "../../../assets/css/variables.less";
@import "./comment.less";

.modal_box {
  height: 100%;
}

.select_wrap {
  padding: 10px;
  // overflow-x: auto;
}

.list {
  flex: 1;
  height: 1%;
  overflow-y: auto;
}

.bottom_content {
  height: 48px;
  box-sizing: border-box;
  font-size: 11px;
  width: 100%;
  background-color: @secondary-color;
  padding: 5px 10px;

  .bottom_item {
    width: 50%;
    color: @textcolor5;
    padding-right: 20px;
    box-sizing: border-box;

    .text {
      width: 110px;
    }
  }
}

.list {
  padding: 0 10px 20px;

  .item {
    padding: 10px;
    border-radius: 5px;
    color: @textcolor5;
    font-size: 10px;

    &:nth-child(odd) {
      background-color: @secondary-color;
    }

    .go_icon {
      font-size: 15px;
      color: @anttextcolor;
    }

    .id {
      width: 50px;
      display: inline-block;
      direction: rtl;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 0 4px;
    }
  }

  .item_info {
    width: 100%;
    padding-right: 10px;
    box-sizing: border-box;

    &:first-child {
      margin-bottom: 5px;
    }

    &.bottom {
      color: @textcolor5;
    }
  }
}

.color5 {
  color: @textcolor3;
}
</style>